import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { ServiceList } from 'app/billing/Models/billing.Models';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { DosageMasterModel } from 'app/EMR/DoctorModels/dosageMaster.model';
import { DosageTimeDetailModal } from 'app/EMR/DoctorModels/dosageTimeDetail.model';
import { EMRService } from 'app/EMR/EMR.service';
import { HelplistService } from 'app/helplist.service';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-dosage-master',
  templateUrl: './dosage-master.component.html',
  styleUrls: ['./dosage-master.component.scss']
})
export class DosageMasterComponent implements OnInit {

  destroy$: Subject<boolean> = new Subject<boolean>();
  private rowClicked: any;
  private dosedataArray: any = [];
  private searchDose: any;
  private searchmedicine: any;
  private todaysdate = new Date();
 // private displayedColumns: string[] = ['MedicineName', 'route', 'dosageCode', 'Mfg', 'Qty', 'Type', 'days', 'unit', 'drugname', 'remakrs'];
   //dataSource = new MatTableDataSource<ServiceList>();
   private selection = new SelectionModel<ServiceList>(true, []);
    private  dosageTimedetails: DosageTimeDetailModal[] = [];
   private  dosageMasterdataModel: DosageMasterModel[] = [];
   private dosageMasterdataobj: DosageMasterModel = {};
   private dosageTimedetailsobj: DosageTimeDetailModal = {};
   private SelectedMedicineArray: any = [];
   private routemainArray: any = [];
   private languagemasterArray: any = [];
   private fontfamilyArray: any = [];
   private searchFontFamily: any;
   private searchlanguage: any;
   private searchmedicineCategory: any;
   private searchroute: any;
   private searchdose: any;
   private showspinner: boolean = false;
   private searchRoute: any;
   private searchDoagecode: any;
   private timeFormatcheck: any;
   private fontFamilytype: String = '';
   private stype:any;
   displayedColumns_medinicecategories: string[] = ['medicineCatName'];
  popbutton: number;
   constructor(private service : VoiceRecognitionService,private dialog: MatDialog, private helplistservice: HelplistService, private datepipe: DatePipe,
     private authService: AuthService, private dashboardService: DashboardService, private dialogRef: MatDialogRef<DosageMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
     private opdvisitService: OpdVisitService, private emrService: EMRService, private exportdata: ExportService) {
       this.service.init()
      }
 
 
   ngOnInit(): void {
    this.popbutton = 0;
    if (this.data.id != null && this.data.id != undefined) {
      this.popbutton = this.data.id;
    } 
     this.dosageMasterdataModel = [];
     this.dosageMasterdataobj = {};
     this.dosageTimedetails = [];
     this.dosageTimedetailsobj = {};
     this.languagemasterArray=[];
     this.fontfamilyArray=[];
     this.routemainArray = [];
     this.showspinner=false;
     this.GetDosageMaster(0,0,0);
     this.timeFormatcheck = 'AM';
     this.dosageMasterdataobj.fK_LanguageId = 1;
     this.rowClicked = -1;
     this.get_drugallergy()
     
     this.getRoutedata(0);
     this.GetLanguageMaster(0);
     this.stype='S';
     this.fontfamilyArray = this.emrService.fontFamilies;
   }
   searchType(event) {
     this.stype = event;
   }
  
  
   seachfontfamily(event: any) {
     
     if (event != null) {
       // document.getElementById("outputtext").style.fontFamily = event;
       this.fontFamilytype = event+'!important';
     } else {
      // document.getElementById("outputtext").style.fontFamily = '';
      this.fontFamilytype ='';
     }
   }
   GetLanguageMaster(lngid) {
     this.languagemasterArray = [];
     this.emrService.GetLanguageMaster(lngid).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
       this.languagemasterArray = x.filter(item => item.isActive == true);
     });
   }
   // get allergy by regid 
   get_drugallergy() {
     this.emrService.drugallergy = [];
     this.emrService.get_allergies().pipe(takeUntil(this.destroy$)).subscribe(
       data => this.success_drugallergy(data), err => this.failed_drugallergy(err)
     )
 
   }
 
   success_drugallergy(data) {
     if(data.statusCode ==8){
 
     }else{
       this.emrService.drugallergy = data;
     }
   }
 
   failed_drugallergy(err) {
 
   }
 
   GetDosageMaster(doseid,type,seachtype) {
     this.emrService.GetDosageMaster(doseid,type,seachtype).pipe(takeUntil(this.destroy$)).subscribe(item => {
       this.dosedataArray = item;
      
     });
   }
   onDosechange(e: any, index: number) {
     
     if (e != null) {
       let doseid = this.dosedataArray.filter(item => item.dosageCode.toLowerCase() == e.toLowerCase());
       this.SelectedMedicineArray[index].fK_DosageId = doseid[0].pK_DosageId;
       this.SelectedMedicineArray[index].dosageCode = e;
       this.SelectedMedicineArray[index].dosageDescription = doseid[0].dosageDescription;
     }
   }
   onRoutechange(e: any, index: number) {
     if (e != null) {
       let routeid = this.routemainArray.filter(item => item.routeName.toLowerCase() == e.toLowerCase());
       this.SelectedMedicineArray[index].fK_RouteId = routeid[0].pK_RouteId;
       this.SelectedMedicineArray[index].route = e;
     }
   }
 
 
   ngOnDestroy() {
     this.destroy$.next(true);
     this.destroy$.unsubscribe();
     this.dosageMasterdataModel = null;
     this.dosageMasterdataobj = null;
     this.dosageTimedetails = null;
     this.dosageTimedetailsobj = null;
     this.languagemasterArray=null;
     this.fontfamilyArray=null;
     this.routemainArray = null;
     this.SelectedMedicineArray=null;
     this.showspinner=null;
     this.languagemasterArray=null;
     this.fontfamilyArray=null;
     this.searchFontFamily=null;
     this.searchlanguage=null;
     this.searchmedicineCategory=null;
     this.searchroute=null;
     this.searchdose=null;
     this.showspinner=null;
     this.searchRoute=null;
     this.searchDoagecode=null;
     this.timeFormatcheck=null;
     this.fontFamilytype=null;
   }

   stockbalqty:any=null;
   selectRow(row) {
     this.selection.toggle(row);
     var checkarraydata = this.SelectedMedicineArray.filter(item => item.pK_MedicineId == row.pK_MedicineId);
     if (checkarraydata.length > 0) {
       this.SelectedMedicineArray = this.SelectedMedicineArray.filter(item => item.pK_MedicineId != row.pK_MedicineId);
       if(this.SelectedMedicineArray.length ==0){
         this.stockbalqty =null; 
       }
      
     } else {
       row.isEdit = false;
       row.pK_TranId = 0;
       let rowdoseid = this.dosedataArray.filter(item => item.dosageCode.toLowerCase() == row.dosageCode.toLowerCase());    
       row.dosageDescription = rowdoseid[0]?.dosageDescription;     
       this.SelectedMedicineArray.push(row);
 
     }
 
     this.SelectedMedicineArray = this.SelectedMedicineArray.reduce((unique, o) => {
       if (!unique.some(obj => obj.medicineName === o.medicineName && obj.pK_MedicineId === o.pK_MedicineId)) {
         unique.push(o);
       }
       return unique;
     }, []);
     var queueproty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "NeedStockinPrescription");
     if(queueproty.length >0 && queueproty[0]?.propertyValue =='Y' && queueproty[0]?.propertyValue !=null && queueproty[0]?.propertyValue !=undefined ){
       this.stockbalqty =row.balanceQty
     }else{
       this.stockbalqty =null; 
     }
   
 
   }
   seachDosageCode(event: any) {
 
   }
  
   dosageMaster() {
     this.GetDosageMaster(0,0,0);
     document.getElementById("dosageMasterModal").style.display = "block";
   }
   canceldosageMaster() {
     this.clearData();
     document.getElementById("dosageMasterModal").style.display = "none";
   }
   clearData() {
     this.dosageMasterdataModel = [];
     this.dosageMasterdataobj = {};
     this.dosageTimedetails = [];
     this.dosageTimedetailsobj = {};
     this.dosageMasterdataobj.fK_LanguageId = 1;
   }
   //Dosage Time 
   dosageTime() {
     this.timeFormatArray = [];
     this._value =0;
     this._hourvalue =0;
     document.getElementById("dosageTimeModal").style.display = "block";
   }
   CanceldosageTime() {
     document.getElementById("dosageTimeModal").style.display = "none";
   }
 
   color: any;
   _value: number = 0;
   _hourvalue: number = 0;
   _step: number = 1;
   _min: number = 0;
   _max: number = 60;
   _hourmax: number = 12;
   _wrap: boolean = false;
 
   myFormGroup = new FormGroup({
     formField: new FormControl(),
   });
 
   set inputValue(_value: number) {
     this._value = this.parseNumber(_value);
   }
 
   set step(_step: number) {
     this._step = this.parseNumber(_step);
   }
 
   set min(_min: number) {
     this._min = this.parseNumber(_min);
   }
 
   set max(_max: number) {
     this._max = this.parseNumber(_max);
   }
 
   set hourmax(_hourmax: number) {
     this._hourmax = this.parseNumber(_hourmax);
   }
 
   set wrap(_wrap: boolean) {
     this._wrap = this.parseBoolean(_wrap);
   }
 
   private parseNumber(num: any): number {
     return +num;
   }
 
   private parseBoolean(bool: any): boolean {
     return !!bool;
   }
 
   setColor(color: string): void {
     this.color = color;
   }
 
   getColor(): string {
     return this.color;
   }
 
   incrementValue(step: number = 1): void {
     let inputValue = this._value + step;
 
     if (this._wrap) {
       inputValue = this.wrappedValue(inputValue);
     }
     this._value = inputValue;
   }
 
   hoursincrementValue(step: number = 1): void {
     let hourinputValue = this._hourvalue + step;
 
     if (this._wrap) {
       hourinputValue = this.hourwrappedValue(hourinputValue);
     }
 
     this._hourvalue = hourinputValue;
   }
 
   private wrappedValue(inputValue): number {
     if (inputValue > this._max) {
       return this._min + inputValue - this._max;
     }
 
     if (inputValue < this._min) {
       if (this._max === 12) {
         return 0;
       }
 
       return this._max + inputValue;
     }
 
     return inputValue;
   }
 
   private hourwrappedValue(hourinputValue): number {
     if (hourinputValue > this._hourmax) {
       return this._min + hourinputValue - this._hourmax;
     }
 
     if (hourinputValue < this._min) {
       if (this._hourmax === 60) {
         return 0;
       }
 
       return this._hourmax + hourinputValue;
     }
 
     return hourinputValue;
   }
 
   shouldDisableDecrement(inputValue: number): boolean {
     return !this._wrap && inputValue <= this._min;
   }
 
   shouldDisableIncrement(inputValue: number): boolean {
     return !this._wrap && inputValue >= this._max;
   }
 
 
   hourshouldDisableDecrement(hourinputValue: number): boolean {
     return !this._wrap && hourinputValue <= this._min;
   }
 
   hourshouldDisableIncrement(hourinputValue: number): boolean {
     return !this._wrap && hourinputValue >= this._hourmax;
   }
 
   changeFormat(event: any) {
     this.timeFormatcheck = event;
   }
   // add time
   timeFormatArray: any = [];
   addTime(hr, min) {
     
     let bindtime = hr + ':' + min + ' ' + this.timeFormatcheck;
     this.timeFormatArray.push({
       "dosageTime": bindtime
     });
   }
   //delete time 
   deletetime(index) {
     this.timeFormatArray.splice(index, 1);
   }
   //transfer dosage time
   TransferDosagetime(rowdata: any) {
     
     if (rowdata.length > 0) {
       rowdata.forEach(item => {
         this.dosageTimedetails.push({
           "pK_DosageTimeDetailId": 0,
           "fK_DosageId": 0,
           "dosageTime": item.dosageTime,
           "isActive": true, "isEdit": false,
           "isDelete": false
         });
       });
 
     }
   }
   removedosagetime(rowdata,index) {
     this.dosageTimedetails.splice(index, 1);
     if(rowdata.pK_DosageTimeDetailId >0){
       this.deleteDosemaster(rowdata,2);
     }
   
   }
   //Search Record 
   searchRecord() {
     document.getElementById("searchRecordModal").style.display = "block";
   }
   cancelsearchRecord() {
     document.getElementById("searchRecordModal").style.display = "none";
     this.searchDose = ''
   }
 
   doaseRowdata(row: any) {
     this.dosageMasterdataobj = row;
     this.GetDosageTimeDetailByDosageId(row.pK_DosageId);
     this.GetDosageDescriptionMasterByDosageId(row.pK_DosageId);
     document.getElementById("searchRecordModal").style.display = "none";
   }
  
   //Quantity Unit
   quantityUnit() {
     document.getElementById("quantityUnitModal").style.display = "block";
   }
   cancelquantityUnit() {
     document.getElementById("quantityUnitModal").style.display = "none";
   }
 
   exportexcel(type: any, ctype: any): void {
 
     this.exportdata.open_loader_Dialogtwo();
     let element = document.getElementById(ctype);
     this.exportdata.Newexportxcel(element, type);
 
   }
 
   getRoutedata(routeid) {
     this.routemainArray = [];
     this.emrService.getRouteMaster(routeid).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
       this.routemainArray = x.filter(item => item.isActive == true);
     })
   }
  

 
   // helplist pop up 

   checkMasterobject:any=[]
   AddMultLangDosage() {
     this.dosageMasterdataModel.push({
       pK_TranId: 0,
       pK_DosageId: 0,
       fK_LanguageId: this.dosageMasterdataobj.fK_LanguageId,
       dosageDescription: this.dosageMasterdataobj.dosageDescription,
       fontName: this.dosageMasterdataobj.fontName,
       isActive: this.dosageMasterdataobj.isActive,
       pK_SynchId: null,
       isEdit: false,
       isDelete: false,
 
     });
     this.checkMasterobject=this.dosageMasterdataModel[0];
   }
   removeMultilandosage(rowdata,index) {
    debugger
     this.dosageMasterdataModel.splice(index, 1);
     if(rowdata.pK_TranId >0){
       this.deleteDosemaster(rowdata,1);
     }
    
   }
   descriptionMaster: any = [];
   timeDetail: any = [];
   dosmasterobj = {};
   saveDosageMaster() {
     this.descriptionMaster = [];
     this.timeDetail = [];
     this.dosmasterobj = {};
     if (this.dosageMasterdataobj.pK_DosageId == 0 || !this.dosageMasterdataobj.pK_DosageId) {
      const existingDosage = this.dosedataArray.filter(item =>
        item.dosageCode.toLowerCase() == this.dosageMasterdataobj.dosageCode.toLowerCase()
      );
  
      if (existingDosage.length > 0) {
        this.dashboardService.openSnackBar("Already exists in the list", "OK");
        this.clearData();
        this.showspinner = false;
        return;
      }
    }
     if (this.dosageTimedetails.length > 0) {
       this.dosageTimedetails.forEach(item => {
         this.timeDetail.push({
           "IsEdit": item.pK_DosageTimeDetailId ? true : false, "IsDelete": false, "PK_DosageTimeDetailId": item.pK_DosageTimeDetailId ? item.pK_DosageTimeDetailId : 0,
           "FK_DosageId": this.dosageMasterdataobj.pK_DosageId ? this.dosageMasterdataobj.pK_DosageId : 0,
           "DosageTime": this.convertTo24Hour(item.dosageTime),
           "IsActive": true
         });
       });
     }
     if (this.dosageMasterdataModel.length > 0) {
       this.dosageMasterdataModel.forEach(item => {
         this.descriptionMaster.push({
           "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
           "FK_DosageId": this.dosageMasterdataobj.pK_DosageId ? this.dosageMasterdataobj.pK_DosageId : 0,
           "FK_LanguageId": item.fK_LanguageId,
           "DosageDescription": item.dosageDescription,
           "IsActive": item.isActive ? true : false,
           "IsEdit": item.pK_TranId ? true : false,
           "isDelete": false,
         });
       });
     }
     if (Object.keys(this.checkMasterobject).length != 0) {
       this.dosmasterobj = {
         "IsEdit": this.dosageMasterdataobj.pK_DosageId ? true : false, "IsDelete": false, "PK_DosageId": this.dosageMasterdataobj.pK_DosageId ? this.dosageMasterdataobj.pK_DosageId : 0,
         "DosageCode": this.dosageMasterdataobj.dosageCode,
         "FK_LanguageId": this.checkMasterobject.fK_LanguageId,
         "DosageDescription": this.checkMasterobject.dosageDescription,
         "fontName": this.checkMasterobject.fontName,
         "IsActive": this.checkMasterobject.isActive ? true : false
       }
     } else {
       this.dosmasterobj = {
         "IsEdit": this.dosageMasterdataobj.pK_DosageId ? true : false, "IsDelete": false, "PK_DosageId": this.dosageMasterdataobj.pK_DosageId ? this.dosageMasterdataobj.pK_DosageId : 0,
         "DosageCode": this.dosageMasterdataobj.dosageCode,
         "FK_LanguageId": this.dosageMasterdataobj.fK_LanguageId,
         "DosageDescription": this.dosageMasterdataobj.dosageDescription,
         "fontName": this.dosageMasterdataobj.fontName,
         "IsActive": this.dosageMasterdataobj.isActive? true : false
       }
     }
 
     let payload = {
       "DosageMaster":
         this.dosmasterobj,
 
       "DosageDescriptionMaster":  this.descriptionMaster
       ,
 
       "DosageTimeDetail": this.timeDetail
     }
 
     this.emrService.InsertDosageMaster(payload).pipe(takeUntil(this.destroy$)).subscribe(data => {
       if (data['statusCode'] == 1) {

        if (this.dosageMasterdataobj.pK_DosageId> 0) {
          this.dashboardService.openSnackBar("Record updated successfully", "OK");
        } else {
          this.dashboardService.openSnackBar("Record saved successfully", "OK");
        }
         this.GetDosageMaster(0,0,0);
         this.checkMasterobject=[];
         this.clearData();
       }
       this.showspinner = false;
     }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
      this.showspinner = false;
      if(this.popbutton >0){
        this.closedailog()
      }
     });
   }

   convertTo24Hour(s) {
     var time = s.split(':');
     var hours = parseInt(time[0]);
     var _ampm = time[1];
     if (_ampm.indexOf('AM') != -1 && hours == 12) {
       time[0] = '00';
     }
     if (_ampm.indexOf('PM') != -1 && hours < 12) {
       time[0] = hours + 12;
     }
     return time.join(':').replace(/(AM|PM)/, '');
   }
   convertTo12formatTime(rowdata) {
     
     if(rowdata.pK_DosageTimeDetailId >0){
       const [hourString, minute] = rowdata.dosageTime.split(":");
       const hour = +hourString % 24;
       return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
     }else{
       return rowdata.dosageTime;
     }
    
 }
   GetDosageTimeDetailByDosageId(id){
     this.dosageTimedetails =[];
     this.emrService.GetDosageTimeDetailByDosageId(id).pipe(takeUntil(this.destroy$)).subscribe((x:any)=>{
       if(x.length >0){
         this.dosageTimedetails =x;
       }
     })
   }
   GetDosageDescriptionMasterByDosageId(id){
     this.dosageMasterdataModel =[];
     this.emrService.GetDosageDescriptionMasterByDosageId(id).pipe(takeUntil(this.destroy$)).subscribe((x:any)=>{
       if(x.length >0){
         this.dosageMasterdataModel =x;
       }
     });
   }
   chngedosageDesc(keyvalue,i){
       if(keyvalue != null){
         this.dosageMasterdataModel[i].dosageDescription=keyvalue;
       }
   }
    deleteDescarray:any=[];
    deletetimemaster:any=[];
   deleteDosemaster(rowdata,type){
    debugger
     this.deleteDescarray =[];
     this.deletetimemaster =[];
      if(this.dosageMasterdataobj.pK_DosageId >0){
       this.showspinner = true;
        if(type ==1){
         this.deleteDescarray.push({
           "PK_TranId": rowdata.pK_TranId,
           "FK_DosageId": rowdata.fK_DosageId,
           "FK_LanguageId": rowdata.fK_LanguageId,
           "DosageDescription": rowdata.dosageDescription,
           "IsActive": true,
           "IsEdit":rowdata.pK_TranId >0 ? true:false,
           "isDelete":rowdata.pK_TranId >0 ? true:false,
         });
        }
        if(type ==2){
         this.deletetimemaster.push({
           "IsEdit":  rowdata.pK_TranId >0 ? true:false , "IsDelete": rowdata.pK_TranId >0 ? true:false, "PK_DosageTimeDetailId": rowdata.pK_DosageTimeDetailId,
           "FK_DosageId": rowdata.fK_DosageId,
           "DosageTime": this.convertTo24Hour(rowdata.dosageTime),
           "IsActive": true
         });
        }
       let payload = {
         "DosageMaster":
         {
           "IsEdit": this.dosageMasterdataobj.pK_DosageId >0? true : false, "IsDelete": this.dosageMasterdataobj.pK_DosageId >0? true : false, "PK_DosageId": this.dosageMasterdataobj.pK_DosageId ? this.dosageMasterdataobj.pK_DosageId : 0,
           "DosageCode": this.dosageMasterdataobj.dosageCode,
           "FK_LanguageId": this.dosageMasterdataobj.fK_LanguageId,
           "DosageDescription": this.dosageMasterdataobj.dosageDescription,
           "fontName": this.dosageMasterdataobj.fontName,
           "IsActive": this.dosageMasterdataobj.isActive
         },
   
         "DosageDescriptionMaster":  this.deleteDescarray
         ,
   
         "DosageTimeDetail":  this.deletetimemaster
       }
   
       this.emrService.InsertDosageMaster(payload).pipe(takeUntil(this.destroy$)).subscribe(data => {
       
           this.dashboardService.openSnackBar("Record saved successfully", "OK");
           if(type =1){
             this.GetDosageDescriptionMasterByDosageId(this.dosageMasterdataobj.pK_DosageId);
           }
           if(type ==2){
             this.GetDosageTimeDetailByDosageId(this.dosageMasterdataobj.pK_DosageId);
           }
      
         this.showspinner = false;
       }, err => {
         this.showspinner = false;
         this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
       });
      }else{
       this.dashboardService.openSnackBar("Record Not Found", "OK");
      }
   }

 
   closedailog() {
     this.dialogRef.close();
   }
   
 }
 